module.exports = __webpack_public_path__ + "img/inCRM.b8d19260.png";